import { Alert, AlertTitle } from "@material-ui/lab";

import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslate } from "ra-core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
  },
}));
const AlertField = () => {
  const translate = useTranslate();
  const classes = useStyles();
  return (
    <Alert color="info" className={classes.root}>
      <AlertTitle>
        {translate("resources.intermediate-technical-reports.alert.title")}
      </AlertTitle>
      <div
        dangerouslySetInnerHTML={{
          __html: translate(
            "resources.intermediate-technical-reports.alert.message"
          ),
        }}
      />
    </Alert>
  );
};

export default AlertField;
